import React, { useState } from "react";
import ReactDOMClient from "react-dom/client";
import { LoginClear } from "./screens/LoginClear";
import { SegmentatioLogo } from "./screens/SegmentatioLogo";
import { MenHorizontal } from "./screens/MenHorizontal";
import { MenLateral } from "./screens/MenLateral";
import "./style.css";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { get, post } from 'aws-amplify/api';




const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [access_token, setAccessToken] = useState(null);

  const updateState = async () => {
    // Cambia el estado para mostrar Componente2
    const token = await getToken();
    setIsLoggedIn(true);
    console.log("isLoggedIn" + isLoggedIn);
    setAccessToken(token);
  };

  async function getToken() {

    try {

      const restOperation = post({ 

        apiName: 'powerbiauth',

        path: '/getToken',

        options: {
          body: {
            "project-name": "edenor-viewer"
          }
        }

      });

      const response = await restOperation.response;

      const json_data = await response['body'].json();
      console.log('GET call succeeded: ', json_data);
      return json_data['powerbi_embed_token'];

    } catch (error) {

      console.log('GET call failed: ', error);

    }

  }

  return (
    <div>
      {isLoggedIn ? (
        // Muestra Componente2 si isLoggedIn es true
        <div className = "contenedor-grid ">
          <div className = "main">
              <PowerBIEmbed
              embedConfig={{
                type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                pageName: '0fb971dab00e2c2d3308',
                id: "6e271d7e-9fae-4bfd-862e-0e2c40185dbb",
                embedUrl: "https://app.powerbi.com/reportEmbed?reportId=6e271d7e-9fae-4bfd-862e-0e2c40185dbb&groupId=64b672a4-fadb-4699-8144-e343c9f69336&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUJSQVpJTC1TT1VUSC1CLVBSSU1BUlktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3d",
                accessToken: access_token,
                tokenType: models.TokenType.Embed,
                settings: {
                  filterPaneEnabled: false,
                  navContentPaneEnabled: false,
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false
                    },
                    pageNavigation: {
                      visible: false
                    }
                  },
                  layoutType: models.LayoutType.Custom,
                  customLayout: {
                    displayOption: models.DisplayOption.FitToWidth
                  },
                }
              }}

              eventHandlers={
                new Map([
                  ['loaded', function () { console.log('Report loaded'); }],
                  ['rendered', function () { console.log('Report rendered'); }],
                  ['error', function (event) { console.log(event.detail); }]
                ])
              }

              cssClassName={"Embed-container-1"}

              getEmbeddedComponent={(embeddedReport) => {
                window.report = embeddedReport;
              }}
            />

            
          </div>
        </div>
      ) : (
        // Muestra Componente1 y pasa la función updateState como prop
        <LoginClear updateState={updateState} />
      )}
    </div>
  );
};

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);

// Renderiza el componente funcional App
root.render(<App />);
